export const DEFAULT_LOGIN_SUPPORT_STYLE = "bars";
export const DEFAULT_AG_LOGIN_DESIGN = "default";

export const AG_LOGIN_DESIGN_OPTIONS = [
  {
    id: "default",
    label: "Default AG login",
    hint: "Current agent login page",
  },
  {
    id: "velki",
    label: "Velki AG login",
    hint: "Separate agent login design for this domain",
  },
] as const;

export const normalizeAgLoginDesign = (value?: string) => {
  return value === "velki" ? "velki" : DEFAULT_AG_LOGIN_DESIGN;
};

export const LOGIN_SUPPORT_STYLE_OPTIONS = [
  {
    id: "bars",
    label: "Default bars",
    hint: "White rounded support buttons (current login page)",
  },
  {
    id: "icon-line",
    label: "Icon with lines",
    hint: "Centered social icons between divider lines (reference style)",
  },
  {
    id: "skysupport",
    label: "Sky support",
    hint: "Only this website. Other websites keep the current login footer.",
  },
] as const;

export const normalizeLoginSupportStyle = (value?: string) => {
  const trimmed = String(value || "").trim();
  if (trimmed === "icon-line" || trimmed === "skysupport") return trimmed;
  return DEFAULT_LOGIN_SUPPORT_STYLE;
};

export function getContactValues(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || "").trim()).filter(Boolean);
  }
  const text = String(value || "").trim();
  return text ? [text] : [];
}

export function isContactShowing(site: any, key: string): boolean {
  return site?.contactShowing?.[key] !== false;
}

export function getVisibleContacts(site: any, key: string): string[] {
  if (!isContactShowing(site, key)) return [];
  return getContactValues(site?.[key]);
}

export function getContactChannel(site: any, key: string) {
  return {
    showing: isContactShowing(site, key),
    values: getContactValues(site?.[key]),
  };
}

export function isAppLinkShowing(site: any): boolean {
  const value = site?.contactShowing?.appLink;
  if (
    !value ||
    value === false ||
    value === "false" ||
    value === 0 ||
    value === "0"
  ) {
    return false;
  }
  return true;
}

export function isViewAllLinksShowing(site: any): boolean {
  const value = site?.contactShowing?.viewAllLinks;
  if (
    !value ||
    value === false ||
    value === "false" ||
    value === 0 ||
    value === "0"
  ) {
    return false;
  }
  return true;
}

export function normalizeExternalHref(value: unknown): string {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("/") && !raw.startsWith("//")) return raw;
  if (/^[\w.-]+\.[a-z]{2,}([/:?#].*)?$/i.test(raw)) return `https://${raw}`;
  return "";
}

export function getAppLinkHref(site: any): string {
  return normalizeExternalHref(site?.appLink);
}

export const telegramHandleLabel = (value?: string) => {
  const handle = String(value || "")
    .trim()
    .replace(/^@/, "");
  return handle ? `t.me/${handle}` : "";
};

export const LOGIN_SUPPORT_URLS = {
  whatsapp:
    process.env.REACT_APP_WHATSAPP_SUPPORT_URL ||
    "https://api.whatsapp.com/send?phone=",
  telegram: process.env.REACT_APP_TG_SUPPORT_URL || "https://t.me/",
  instagram:
    process.env.REACT_APP_IG_SUPPORT_URL || "https://www.instagram.com/",
};

export function getViewAllLinksHref(site: any): string {
  return normalizeExternalHref(site?.viewAllLinks);
}

